





























import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';
import {
  Employee,
  EmployeeType,
  IEmployee,
  IEmployeeData,
  TimeOffTypeFieldError
} from '@/models';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';

import { IEmployeeFetchParams } from '@/services';
import { getPropertyFromItem } from '@/utils/helpers';

export default mixins(Functions, auth).extend({
  name: 'TimeOffSupervisorEmployeePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'Type'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | TimeOffTypeFieldError>,
      default: () => []
    },

    isEdit: Boolean
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      loading: false,
      localEmployeesList: [] as IEmployee[]
    };
  },

  computed: {
    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof TimeOffTypeFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    },

    supervisorEmployees(): IEmployeeData[] {
      return this.isEdit ? [this.internalValue] : this.localEmployeesList;
    }
  },


  mounted() {
    this.searchSupervisorEmployees();
  },

  methods: {
    ...mapActions({
      fetchSupervisorEmployees: 'employee/fetchSupervisorEmployees',
      fetchEmployeeWorkSchedule: 'employee/fetchEmployeeWorkSchedule'
    }),

    genEmployeeWorkSchedule() {
      if (this.internalValue) {
        this.loading = true;
        this.fetchEmployeeWorkSchedule(this.getEmployeeValue(this.internalValue))
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
    },

    employeeStringRepresentation(value: IEmployee) {
      return `${value.first_name} ${value.last_name}`.trim();
    },


    searchSupervisorEmployees() {
      this.loading = true;

      this.fetchSupervisorEmployees({
        supervisor: this.currentUser.employee,
        type: EmployeeType.Salary
      } as IEmployeeFetchParams)
        .then((data: IEmployee[]) => {
          this.localEmployeesList = data.map(employee => new Employee(employee))
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    getEmployeeValue(employee: IEmployeeData) {
      return getPropertyFromItem(employee, 'id', employee);
    }
  }
});
